import { NavigationMenuItem } from "../../Model/Navigation/NavigationMenuItem";

export const NAVIGATION_MENU: NavigationMenuItem[] = [
    {
        id: 1,
        text: 'Kataloge',
        icon: 'icon-glyphicons-basic-72-book',
        path: 'catalogs',
        visible: false,
        hasRequiredAddons: (loginService) => true,
        isUserAllowedToView: (isReadOnlyUser) => true,
    },
    {
        id: 2,
        text: 'Suche',
        icon: 'icon-glyphicons-basic-28-search',
        path: 'search',
        visible: false,
        hasRequiredAddons: (loginService) => true,
        isUserAllowedToView: (isReadOnlyUser) => true,
    },
    {
        id: 15,
        text: 'Kataloge kombinieren',
        icon: 'icon-glyphicons-basic-84-random',
        path: 'combineCatalogs',
        visible: false,
        hasRequiredAddons: (loginService) => true,
        isUserAllowedToView: (isReadOnlyUser) => !isReadOnlyUser,
    },
    {
        id: 12,
        text: 'Excel Templates',
        icon: 'icon-glyphicons-basic-120-table',
        path: 'templates',
        visible: false,
        hasRequiredAddons: (loginService) => true,
        isUserAllowedToView: (isReadOnlyUser) => !isReadOnlyUser,
    },
    {
        id: 4,
        text: 'Übersetzungen',
        icon: 'icon-glyphicons-basic-579-translate-alt',
        path: 'translation',
        visible: false,
        hasRequiredAddons: (loginService) => loginService.hasAddonTranslate,
        isUserAllowedToView: (isReadOnlyUser) => !isReadOnlyUser,
    },
    {
        id: 5,
        text: 'Klassifizierung',
        icon: 'icon-glyphicons-basic-538-tasks',
        path: 'classification',
        visible: false,
        hasRequiredAddons: (loginService) => true,
        isUserAllowedToView: (isReadOnlyUser) => !isReadOnlyUser,
    },
    {
        id: 6,
        text: 'Gefahrstoffklassen',
        icon: 'icon-glyphicons-basic-642-radioactive',
        path: 'hazmatclasses',
        visible: false,
        hasRequiredAddons: (loginService) => true,
        isUserAllowedToView: (isReadOnlyUser) => !isReadOnlyUser,
    },
    {
        id: 7,
        text: 'Garantieklassen',
        icon: 'icon-glyphicons-basic-320-certificate',
        path: 'warrantyClasses',
        visible: false,
        hasRequiredAddons: (loginService) => true,
        isUserAllowedToView: (isReadOnlyUser) => !isReadOnlyUser,
    },
    {
        id: 8,
        text: 'Update Templates',
        icon: 'icon-glyphicons-basic-120-table',
        path: 'updateTemplates',
        visible: false,
        hasRequiredAddons: (loginService) => true,
        isUserAllowedToView: (isReadOnlyUser) => !isReadOnlyUser,
    },
    {
        id: 9,
        text: 'Status',
        icon: 'icon-glyphicons-basic-945-traffic-lights',
        path: 'states',
        visible: false,
        hasRequiredAddons: (loginService) => true,
        isUserAllowedToView: (isReadOnlyUser) => !isReadOnlyUser,
    },
    {
        id: 10,
        text: 'Produktdatenblatt Designer',
        icon: 'icon-glyphicons-basic-16-print',
        path: 'productReportDesigner',
        visible: false,
        hasRequiredAddons: (loginService) => true,
        isUserAllowedToView: (isReadOnlyUser) => !isReadOnlyUser,
    },
    {
        id: 14,
        text: 'Artikelnummern Mapping',
        icon: 'icon-glyphicons-basic-697-directions-sign',
        path: 'supplierPidMapping',
        visible: false,
        hasRequiredAddons: (loginService) => loginService.hasAddonWawiErp,
        isUserAllowedToView: (isReadOnlyUser) => !isReadOnlyUser,
    },
    {
        id: 17,
        text: 'EDE Sortiment',
        icon: 'icon-glyphicons-basic-588-book-open-text',
        path: 'edeSortiment',
        visible: false,
        hasRequiredAddons: (loginService) => loginService.hasAddonEDESortimentsAbo,
        isUserAllowedToView: (isReadOnlyUser) => !isReadOnlyUser,
    },
    {
        id: 18,
        text: 'Wawi Listen',
        icon: 'icon-glyphicons-basic-115-list',
        path: 'wawiList',
        visible: false,
        hasRequiredAddons: (loginService) => loginService.hasAddonWawiErp,
        isUserAllowedToView: (isReadOnlyUser) => !isReadOnlyUser,
    },
    {
        id: 19,
        text: 'KI Prompts',
        icon: 'icon-glyphicons-basic-819-robot',
        path: 'prompts',
        visible: false,
        hasRequiredAddons: (loginService) => loginService.hasAddonKI_TEXTS,
        isUserAllowedToView: (isReadOnlyUser) => !isReadOnlyUser,
    },
    {
        id: 20,
        text: 'Multishop Export',
        icon: 'icon-glyphicons-basic-400-export',
        path: 'multishopExport',
        visible: false,
        hasRequiredAddons: (loginService) => loginService.hasAddonOSG,
        isUserAllowedToView: (isReadOnlyUser) => !isReadOnlyUser,
    },
    {
        id: 22,
        text: 'Features',
        icon: 'icon-glyphicons-basic-140-adjust',
        path: 'validfeature',
        visible: false,
        hasRequiredAddons: (loginService) => true,
        isUserAllowedToView: (isReadOnlyUser) => !isReadOnlyUser,
    },
    {
        id: 21,
        text: 'Validierung',
        icon: 'icon-glyphicons-basic-304-verify-check',
        path: 'validation',
        visible: false,
        hasRequiredAddons: (loginService) => loginService.hasAddonVALIDATION,
        isUserAllowedToView: (isReadOnlyUser) => !isReadOnlyUser,
    },
    {
        id: 23,
        text: 'Lieferanten',
        icon: 'icon-glyphicons-basic-59-truck',
        path: 'datasources',
        visible: false,
        hasRequiredAddons: (loginService) => loginService.hasAddonDataSources,
        isUserAllowedToView: (isReadOnlyUser) => !isReadOnlyUser,
    },
    {
        id: 24,
        text: 'Oxomi Sortiment',
        icon: 'icon-glyphicons-basic-oxomi',
        path: 'oxomi-sortiment',
        visible: false,
        hasRequiredAddons: (loginService) => loginService.hasAddonOXOMI,
        isUserAllowedToView: (isReadOnlyUser) => !isReadOnlyUser,
    },
    {
        id: 25,
        text: 'Workflows',
        icon: 'icon-glyphicons-basic-314-hammer',
        path: 'workflows',
        visible: false,
        hasRequiredAddons: (loginService) => loginService.hasAddonWorkflow,
        isUserAllowedToView: (isReadOnlyUser) => !isReadOnlyUser,
    },
    {
        id: 27,
        text: 'Marken',
        icon: 'icon-glyphicons-basic-324-shield-empty-star',
        path: 'brands',
        visible: false,
        hasRequiredAddons: (loginService) => loginService.hasAddonDataSources,
        isUserAllowedToView: (isReadOnlyUser) => !isReadOnlyUser,
    }
];

export const DATAPROCESS_NAVIGATION_MENU: NavigationMenuItem[] = [
    {
        id: 1,
        text: 'Dashboard',
        icon: 'icon-glyphicons-basic-670-dashboard',
        path: 'dataprocess/dashboard',
        visible: false,
        hasRequiredAddons: (loginService) => loginService.hasAddonDataProcess,
        isUserAllowedToView: (isReadOnlyUser) => true,
    },
    {
        id: 2,
        text: 'Importe',
        icon: 'icon-glyphicons-basic-302-square-download',
        path: 'dataprocess/imports',
        visible: false,
        hasRequiredAddons: (loginService) => loginService.hasAddonDataProcess,
        isUserAllowedToView: (isReadOnlyUser) => true,
    },
    {
        id: 3,
        text: 'Preparation',
        icon: 'icon-glyphicons-basic-151-square-edit',
        path: 'dataprocess/preparation',
        visible: false,
        hasRequiredAddons: (loginService) => loginService.hasAddonDataProcess,
        isUserAllowedToView: (isReadOnlyUser) => true,
    },
    {
        id: 4,
        text: 'Golden Record',
        icon: 'icon-glyphicons-basic-425-crown',
        path: 'dataprocess/golden-record',
        visible: false,
        hasRequiredAddons: (loginService) => loginService.hasAddonDataProcess,
        isUserAllowedToView: (isReadOnlyUser) => true,
    },
    {
        id: 5,
        text: 'Exporte',
        icon: 'icon-glyphicons-basic-301-square-upload',
        path: 'dataprocess/exports',
        visible: false,
        hasRequiredAddons: (loginService) => loginService.hasAddonDataProcess,
        isUserAllowedToView: (isReadOnlyUser) => true,
    }
];
